// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CarrerUp Mobile Arena
   Native-only presentation layer. The responsive website remains untouched. */

html.native-app {
  --cu-mobile-orange: #e95a13;
  --cu-mobile-navy: #17344f;
  --cu-mobile-blue: #4e7799;
  --cu-mobile-surface: #ffffff;
  --cu-mobile-canvas: #f5f7f9;
  --cu-mobile-line: rgba(78, 119, 153, .14);
  --cu-mobile-shadow: 0 10px 30px rgba(23, 52, 79, .08);
  background: var(--cu-mobile-canvas);
}

html.native-app body,
html.native-app #root {
  background: var(--cu-mobile-canvas);
}

html.native-app button,
html.native-app a,
html.native-app [role="button"] {
  -webkit-tap-highlight-color: transparent;
}

/* Instagram-inspired native top bar. */
html.native-app .admin-dash-navbar {
  box-sizing: border-box;
  min-height: calc(58px + env(safe-area-inset-top, 0px));
  padding: env(safe-area-inset-top, 0px) 14px 0 !important;
  border-bottom: 0;
  background: transparent !important;
  box-shadow: none !important;
  backdrop-filter: none;
}

html.native-app .admin-dash-navbar.native-subpage-header {
  display: none !important;
}

html.native-app .dashboard-main:not(.feed-canvas) {
  padding-top: env(safe-area-inset-top, 0px) !important;
}

html.native-app .admin-dash-navbar > .admin-dash-navbar-left,
html.native-app .admin-dash-navbar > .admin-dash-navbar-center,
html.native-app .admin-dash-navbar > .admin-dash-navbar-right {
  display: none !important;
}

html.native-app .native-topbar {
  display: grid;
  grid-template-columns: 44px 1fr auto;
  align-items: center;
  width: 100%;
  height: 58px;
}

html.native-app .native-topbar button {
  position: relative;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: #17344f;
  border: 0;
  border-radius: 50%;
  background: transparent;
  font-size: 21px;
}

html.native-app .native-topbar-create {
  font-size: 23px !important;
}

html.native-app .native-topbar-brand {
  justify-self: center;
  width: 132px;
  height: 38px;
  object-fit: contain;
}

html.native-app .native-topbar-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

html.native-app .native-notification-button > span {
  position: absolute;
  top: 1px;
  right: -2px;
  display: grid;
  min-width: 17px;
  height: 17px;
  padding: 0 3px;
  place-items: center;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 10px;
  background: #e95a13;
  font-size: 8px;
  font-weight: 800;
}

html.native-app .admin-dash-navbar-left {
  min-width: 0;
}

html.native-app .admin-dash-logo img {
  width: 38px !important;
  height: 38px !important;
  object-fit: contain;
}

html.native-app .admin-dash-navbar-right {
  gap: 7px;
}

html.native-app .admin-dash-icon-wrapper,
html.native-app .notif-bell-wrap {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 12px;
}

/* Five-destination native navigation. */
html.native-app .mobile-bottom-nav {
  box-sizing: border-box;
  right: max(8px, env(safe-area-inset-right, 0px)) !important;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px) !important;
  left: max(8px, env(safe-area-inset-left, 0px)) !important;
  z-index: 99990;
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  width: auto !important;
  min-height: 58px;
  padding: 3px 5px 2px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: rgba(255, 255, 255, .97) !important;
  box-shadow: 0 -1px rgba(23, 52, 79, .08) !important;
  backdrop-filter: blur(20px) !important;
}

html.native-app .mobile-bottom-nav > div {
  position: relative;
  display: flex !important;
  min-width: 0;
  min-height: 50px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 !important;
  color: #71899b !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

html.native-app .mobile-bottom-nav > .mobile-native-only {
  display: flex;
}

html.native-app .mobile-bottom-nav > .mobile-web-only {
  display: none !important;
}

html.native-app .mobile-bottom-nav > div::before,
html.native-app .mobile-bottom-nav > div::after {
  display: none !important;
}

html.native-app .mobile-bottom-nav > div > svg {
  width: 19px;
  height: 19px;
  color: inherit !important;
  filter: none !important;
  transform: none !important;
  animation: none !important;
}

html.native-app .mobile-bottom-nav > div > span {
  display: block;
  max-width: 100%;
  overflow: hidden;
  font-size: 8.5px;
  font-weight: 750;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

html.native-app .mobile-bottom-nav > div.active {
  color: var(--cu-mobile-orange) !important;
  background: transparent !important;
}

html.native-app .native-create-overlay {
  position: fixed;
  z-index: 100500;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 18px 12px calc(env(safe-area-inset-bottom, 0px) + 14px);
  box-sizing: border-box;
  background: rgba(8, 22, 34, .48);
  backdrop-filter: blur(7px);
}

html.native-app .native-create-sheet {
  width: 100%;
  padding: 18px;
  box-sizing: border-box;
  border-radius: 26px;
  background: #fff;
  box-shadow: 0 24px 65px rgba(10, 28, 42, .28);
  animation: nativeSheetIn .28s cubic-bezier(.2, .8, .2, 1);
}

html.native-app .native-create-sheet header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

html.native-app .native-create-sheet header small {
  color: #e95a13;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .12em;
  text-transform: uppercase;
}

html.native-app .native-create-sheet header h2 {
  margin: 2px 0 0;
  color: #17344f;
  font-size: 21px;
}

html.native-app .native-create-sheet header button {
  display: grid;
  width: 38px;
  height: 38px;
  padding: 0;
  place-items: center;
  color: #17344f;
  border: 0;
  border-radius: 50%;
  background: #f1f4f6;
}

html.native-app .native-create-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

html.native-app .native-create-grid button {
  display: flex;
  min-height: 76px;
  align-items: center;
  gap: 12px;
  padding: 14px;
  color: #17344f;
  border: 0;
  border-radius: 17px;
  background: #f3f6f8;
  font-size: 14px;
  font-weight: 750;
  text-align: left;
}

html.native-app .native-create-grid button svg {
  box-sizing: content-box;
  width: 18px;
  height: 18px;
  padding: 10px;
  color: #e95a13;
  border-radius: 12px;
  background: #fff0e8;
}

@keyframes nativeSheetIn {
  from { opacity: 0; transform: translateY(32px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Feed: immersive mobile cards, no desktop side content. */
html.native-app .dashboard-main.feed-canvas {
  padding: calc(env(safe-area-inset-top, 0px) + 70px) 0 108px !important;
  background: #fff;
}

html.native-app .feed-canvas .feed,
html.native-app .feed-layout,
html.native-app .feed-stream {
  width: 100% !important;
  max-width: none !important;
}

html.native-app .feed-composer {
  display: none !important;
}

html.native-app .feed-mobile-sections {
  display: none !important;
}

html.native-app .native-search-page {
  min-height: calc(100dvh - 150px);
  padding: 12px 14px 100px;
  box-sizing: border-box;
  background: #fff;
}

html.native-app .native-section-back {
  display: flex;
  width: 100%;
  height: 48px;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  color: #17344f;
  border: 0;
  border-bottom: 1px solid #e9edf0;
  background: #fff;
  font-size: 16px;
  font-weight: 750;
  text-align: left;
}

html.native-app .native-page-header {
  display: grid;
  grid-template-columns: 42px 1fr 42px;
  align-items: center;
  min-height: 48px;
}

html.native-app .native-page-header button {
  display: grid;
  width: 38px;
  height: 38px;
  padding: 0;
  place-items: center;
  color: #17344f;
  border: 0;
  background: transparent;
}

html.native-app .native-page-header h1 {
  margin: 0;
  color: #17344f;
  font-size: 19px;
  text-align: center;
}

html.native-app .native-search-field {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 0 16px;
  padding: 0 13px;
  border-radius: 14px;
  background: #f0f3f5;
  color: #71899b;
}

html.native-app .native-search-field input {
  width: 100%;
  height: 48px;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #17344f;
  font-size: 15px;
}

html.native-app .native-search-field button {
  display: grid;
  padding: 5px;
  place-items: center;
  color: #71899b;
  border: 0;
  background: transparent;
}

html.native-app .native-search-user {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 10px 2px;
  color: #17344f;
  border: 0;
  border-bottom: 1px solid #edf0f2;
  background: #fff;
  text-align: left;
}

html.native-app .native-search-avatar {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  overflow: hidden;
  place-items: center;
  border-radius: 50%;
  background: #edf2f5;
}

html.native-app .native-search-avatar img { width: 100%; height: 100%; object-fit: cover; }
html.native-app .native-search-user > span:last-child { display: grid; gap: 3px; }
html.native-app .native-search-user small { color: #7890a2; }
html.native-app .native-search-state { padding: 30px 10px; color: #7890a2; text-align: center; }

html.native-app .feed-canvas .post {
  width: 100%;
  margin: 0;
  padding: 0 0 8px;
  overflow: hidden;
  border: 0;
  border-bottom: 8px solid #eef2f4;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

html.native-app .feed-canvas .post-header {
  padding: 14px 15px 11px;
}

html.native-app .feed-canvas .post-header img,
html.native-app .feed-canvas .post-header .post-user-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

html.native-app .feed-canvas .post-text-wrapper {
  padding: 0 15px 12px;
}

html.native-app .feed-canvas .post-image,
html.native-app .feed-canvas .post-video-container {
  width: 100%;
  max-height: 72dvh;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: #102432;
  cursor: default;
  object-fit: contain;
}

html.native-app .feed-canvas .post-actions {
  margin: 0;
  padding: 10px 13px 8px;
  border: 0;
  background: transparent;
}

html.native-app .feed-canvas .post-actions button {
  min-height: 38px;
  border-radius: 0;
  background: transparent !important;
}

html.native-app .native-feed-welcome {
  display: grid;
  gap: 3px;
  padding: 17px 15px 13px;
  border-bottom: 1px solid #e9edef;
  background: #fff;
}

html.native-app .native-feed-welcome small {
  color: #e95a13;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: .14em;
  text-transform: uppercase;
}

html.native-app .native-feed-welcome strong {
  color: #17344f;
  font-size: 18px;
  font-weight: 780;
}

html.native-app .native-pull-refresh {
  display: grid;
  height: var(--pull-distance, 0px);
  overflow: hidden;
  place-items: end center;
  background: #fff;
  transition: height .18s ease;
}

html.native-app .native-pull-refresh > span {
  width: 22px;
  height: 22px;
  margin-bottom: 9px;
  border: 2px solid #d7e0e5;
  border-top-color: #e95a13;
  border-radius: 50%;
  transform: rotate(calc(var(--pull-distance, 0px) * 3));
}

html.native-app .native-pull-refresh.refreshing > span {
  animation: nativePullSpin .75s linear infinite;
}

@keyframes nativePullSpin { to { transform: rotate(360deg); } }

/* Instagram-like post viewer on native mobile. */
html.native-app .pv-overlay {
  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;
  background: #0d1f2c !important;
  backdrop-filter: none !important;
}

html.native-app .pv-modal {
  width: 100% !important;
  height: 100% !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

html.native-app .pv-close {
  top: 10px;
  left: 10px;
  right: auto;
  border: 0;
  border-radius: 50%;
  background: rgba(8, 23, 34, .72);
}

/* Profile: native hierarchy and Instagram-style back control. */
html.native-app .pro-profile-container {
  padding: calc(env(safe-area-inset-top, 0px) + 10px) 0 105px !important;
  background: var(--cu-mobile-canvas);
}

html.native-app .profile-container {
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
}

html.native-app .sport-profile-topbar {
  position: sticky;
  z-index: 30;
  top: env(safe-area-inset-top, 0px);
  padding: 8px 10px;
  background: rgba(245, 247, 249, .92);
  backdrop-filter: blur(16px);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

html.native-app .native-profile-menu-wrap {
  position: relative;
  z-index: 50;
  display: block;
}

html.native-app .native-profile-menu-trigger {
  position: relative;
  z-index: 52;
  display: grid;
  width: 40px;
  height: 40px;
  padding: 0;
  place-items: center;
  color: #17344f;
  border: 0;
  border-radius: 50%;
  background: transparent;
  font-size: 20px;
}

html.native-app .native-profile-menu-backdrop {
  position: fixed;
  z-index: 49;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(10, 25, 38, .22);
  backdrop-filter: blur(3px);
}

html.native-app .native-profile-menu {
  position: absolute;
  z-index: 51;
  top: 48px;
  right: 0;
  display: grid;
  width: min(270px, calc(100vw - 28px));
  padding: 8px;
  border: 1px solid var(--cu-mobile-line);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 20px 55px rgba(14, 38, 56, .22);
}

html.native-app .native-profile-menu > button {
  display: flex;
  min-height: 49px;
  align-items: center;
  gap: 13px;
  padding: 0 12px;
  color: #17344f;
  border: 0;
  border-radius: 12px;
  background: transparent;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
}

html.native-app .native-profile-menu > button svg {
  width: 18px;
  color: #71899b;
}

html.native-app .native-profile-menu > .native-profile-logout,
html.native-app .native-profile-menu > .native-profile-logout svg {
  color: #d44334;
}

html.native-app .sport-back-btn,
html.native-app .back-btn {
  width: 40px !important;
  min-width: 40px;
  height: 40px;
  padding: 0 !important;
  display: grid !important;
  place-items: center;
  overflow: hidden;
  border: 1px solid var(--cu-mobile-line) !important;
  border-radius: 50% !important;
  color: var(--cu-mobile-navy) !important;
  background: rgba(255, 255, 255, .96) !important;
  box-shadow: 0 5px 14px rgba(23, 52, 79, .1) !important;
}

html.native-app .sport-back-btn .back-arrow {
  font-size: 0;
}

html.native-app .sport-back-btn .back-arrow::before {
  content: "‹";
  font-size: 31px;
  font-weight: 400;
  line-height: 1;
}

html.native-app .sport-back-btn .back-content {
  display: none !important;
}

html.native-app .main-profile-header,
html.native-app .profile-summary,
html.native-app .profile-links-section,
html.native-app .highlights-section,
html.native-app .tabs,
html.native-app .posts-grid {
  margin-right: 10px !important;
  margin-left: 10px !important;
}

html.native-app .main-profile-header {
  padding: 18px 14px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

html.native-app .cta-buttons .btn {
  min-height: 44px;
  border-radius: 13px;
}

html.native-app .cta-buttons .profile-edit-btn {
  display: none !important;
}

html.native-app .profile-summary,
html.native-app .profile-links-section,
html.native-app .highlights-section {
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

html.native-app .profile-container > .tabs {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 !important;
  border-top: 1px solid #e8edf0 !important;
  border-bottom: 1px solid #e8edf0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

html.native-app .profile-container > .tabs button {
  position: relative;
  display: grid;
  height: 52px;
  padding: 0;
  place-items: center;
  color: #8aa0b0;
  border: 0;
  background: transparent !important;
}

html.native-app .profile-container > .tabs button.active {
  color: #17344f !important;
}

html.native-app .profile-container > .tabs button.active::after {
  content: "";
  position: absolute;
  right: 18%;
  bottom: -1px;
  left: 18%;
  height: 2px;
  border-radius: 2px;
  background: #17344f;
}

html.native-app .profile-container > .tabs .profile-tab-label {
  display: none;
}

html.native-app .profile-container > .tabs .native-profile-tab-icon {
  display: grid;
  place-items: center;
  font-size: 19px;
}

html.native-app .native-profile-dock {
  box-sizing: border-box;
  position: fixed;
  z-index: 99990;
  right: max(8px, env(safe-area-inset-right, 0px));
  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);
  left: max(8px, env(safe-area-inset-left, 0px));
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  width: auto;
  min-height: 58px;
  padding: 3px 5px 2px;
  border: 0;
  border-radius: 0;
  background: rgba(255, 255, 255, .97);
  box-shadow: 0 -1px rgba(23, 52, 79, .08);
  backdrop-filter: blur(20px);
}

html.native-app .native-profile-dock button {
  display: flex;
  min-width: 0;
  min-height: 51px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0;
  color: #71899b;
  border: 0;
  border-radius: 0;
  background: transparent;
}

html.native-app .native-profile-dock button svg { width: 19px; height: 19px; }
html.native-app .native-profile-dock button span { max-width: 100%; overflow: hidden; font-size: 8.5px; font-weight: 750; text-overflow: ellipsis; white-space: nowrap; }
html.native-app .native-profile-dock button.active { color: #e95a13; background: transparent; }

/* Matching becomes a native discovery deck while preserving its data/actions. */
html.native-app .matching-page {
  box-sizing: border-box;
  width: 100%;
  min-height: 100dvh;
  padding: 14px 10px 108px;
  background: var(--cu-mobile-canvas);
}

html.native-app .matching-hero {
  margin-bottom: 14px;
  padding: 19px 17px;
  border-radius: 20px;
  box-shadow: var(--cu-mobile-shadow);
}

html.native-app .matching-page .suggestion-row {
  gap: 10px;
  margin-inline: -10px;
  padding: 2px 10px 18px;
  scroll-padding-inline: 10px;
  scrollbar-width: none;
}

html.native-app .matching-page .suggestion-row::-webkit-scrollbar {
  display: none;
}

html.native-app .matching-page .match-card,
html.native-app .matching-page .match-card-mine {
  border-radius: 20px;
  box-shadow: var(--cu-mobile-shadow);
}

html.native-app .matching-list-scroll {
  max-height: none;
  overflow: visible;
  padding: 0;
}

html.native-app .matching-list .match-card-mine {
  grid-template-columns: 1fr;
  gap: 9px;
  padding: 15px;
}

/* Network and chat retain every action with a lighter native canvas. */
html.native-app .network-page {
  box-sizing: border-box;
  width: 100%;
  padding: 14px 10px 108px !important;
  background: var(--cu-mobile-canvas);
}

html.native-app .network-page .network-card {
  border-radius: 19px;
  box-shadow: var(--cu-mobile-shadow);
}

html.native-app .ig-chat-layout {
  height: calc(100dvh - env(safe-area-inset-top, 0px) - 74px);
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: var(--cu-mobile-surface);
}

html.native-app .ig-conversation-item,
html.native-app .ig-message-bubble {
  border-radius: 16px;
}

/* Settings and role pages share mobile-safe spacing without changing content. */
html.native-app .settings-container,
html.native-app .profile-settings-container,
html.native-app .club-offers-page,
html.native-app .offer-details-page,
html.native-app .offer-applications-page {
  box-sizing: border-box;
  width: 100% !important;
  max-width: none !important;
  padding-right: 10px !important;
  padding-bottom: calc(104px + env(safe-area-inset-bottom, 0px)) !important;
  padding-left: 10px !important;
}

@media (max-width: 370px) {
  html.native-app .mobile-bottom-nav > div > span {
    font-size: 7.5px;
  }

  html.native-app .mobile-bottom-nav > div > svg {
    width: 17px;
    height: 17px;
  }
}

@media (orientation: landscape) and (max-height: 520px) {
  html.native-app .mobile-bottom-nav {
    min-height: 56px;
    padding-block: 4px !important;
  }

  html.native-app .mobile-bottom-nav > div {
    min-height: 46px;
  }

  html.native-app .mobile-bottom-nav > .mobile-create-action {
    transform: translateY(-10px);
  }
}
/* Native profile correction pass: full-screen panels and compact Instagram layout. */
html.native-app .pro-profile-container,
html.native-app .profile-container {
  min-height: 100dvh;
  overflow: visible !important;
}

html.native-app .native-profile-menu {
  position: fixed;
  z-index: 51;
  inset: 0 0 0 auto;
  display: flex;
  width: min(88vw, 360px);
  padding: calc(env(safe-area-inset-top, 0px) + 72px) 14px calc(env(safe-area-inset-bottom, 0px) + 20px);
  box-sizing: border-box;
  flex-direction: column;
  border: 0;
  border-radius: 0;
  background: #fff;
  box-shadow: -18px 0 48px rgba(14, 38, 56, .2);
  animation: nativePanelFromRight .28s cubic-bezier(.2, .8, .2, 1);
}

@keyframes nativePanelFromRight {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

@keyframes nativePanelToRight { to { transform: translateX(100%); } }

html.native-app .profile-header {
  display: grid !important;
  grid-template-columns: 88px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
}

html.native-app .photo-wow {
  width: 82px !important;
  height: 82px !important;
  min-width: 82px !important;
}

html.native-app .profile-info { min-width: 0; padding: 0 !important; }

html.native-app .profile-info .stats {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px !important;
  margin-top: 12px !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

html.native-app .profile-info .stats > div {
  min-width: 0;
  padding: 0 2px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  text-align: center;
}

html.native-app .profile-info .stats strong { font-size: 15px !important; }
html.native-app .profile-info .stats span { font-size: 9px !important; }

html.native-app .cta-buttons {
  display: flex !important;
  width: auto !important;
  margin: 10px 14px !important;
  flex-wrap: wrap;
  gap: 7px !important;
}

html.native-app .cta-buttons .btn {
  width: auto !important;
  min-width: 0 !important;
  min-height: 36px !important;
  flex: 0 1 auto !important;
  padding: 7px 12px !important;
  border-radius: 9px !important;
  font-size: 12px !important;
}

html.native-app .skeleton-highlight { display: none !important; }

html.native-app .follow-page-overlay {
  z-index: 100200;
  display: block !important;
  padding: 0 !important;
  background: #fff !important;
  backdrop-filter: none !important;
}

html.native-app .follow-page,
html.native-app .follow-page.closing {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100dvh !important;
  max-width: none !important;
  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;
  box-sizing: border-box;
  border: 0 !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
  animation: nativePanelFromRight .3s cubic-bezier(.2, .8, .2, 1) !important;
}

html.native-app .follow-page.closing { animation: nativePanelToRight .25s ease forwards !important; }
html.native-app .follow-page .follow-header { min-height: 56px; padding: 8px 12px !important; background: #fff; }
html.native-app .follow-page .follow-item { border: 0 !important; border-bottom: 1px solid #edf0f2 !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; }

html.native-app .mobile-bottom-nav,
html.native-app .native-profile-dock {
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100% !important;
  min-height: calc(58px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px) !important;
}

html.native-app .mobile-bottom-nav > div > svg,
html.native-app .native-profile-dock button svg {
  width: 22px !important;
  height: 22px !important;
  stroke-width: 1.4;
}

html.native-app .pro-profile-container { background: #fff !important; }
html.native-app .main-profile-header { margin: 0 !important; }
html.native-app .profile-summary,
html.native-app .profile-links-section,
html.native-app .highlights-section { margin-right: 14px !important; margin-left: 14px !important; }

html.native-app .post-page-overlay {
  z-index: 100250 !important;
  display: block !important;
  padding: 0 !important;
  background: #fff !important;
  backdrop-filter: none !important;
  animation: nativePanelFromRight .3s cubic-bezier(.2, .8, .2, 1);
}

html.native-app .post-page-overlay > .post-modal {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100dvh !important;
  max-height: none !important;
  border-radius: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
}

html.native-app .post-page-overlay .pv-overlay {
  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;
  background: #fff !important;
}

html.native-app .post-page-overlay .pv-modal {
  width: 100vw !important;
  height: 100dvh !important;
  max-height: none !important;
  border-radius: 0 !important;
  background: #fff !important;
}

html.native-app .post-page-overlay .pv-close {
  position: fixed !important;
  top: calc(env(safe-area-inset-top, 0px) + 8px) !important;
  left: 10px !important;
  z-index: 100300 !important;
}
`, "",{"version":3,"sources":["webpack://./src/mobile-native.css"],"names":[],"mappings":"AAAA;8EAC8E;;AAE9E;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;EACzC,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,sDAAsD;EACtD,wDAAwD;EACxD,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,2DAA2D;EAC3D,+DAA+D;EAC/D,yDAAyD;EACzD,cAAc;EACd,wBAAwB;EACxB,gDAAgD;EAChD,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;EAC3B,+CAA+C;EAC/C,mDAAmD;EACnD,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,gEAAgE;EAChE,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,2DAA2D;AAC3D;EACE,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,4CAA4C,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC1F,wDAAwD,aAAa,EAAE,QAAQ,EAAE;AACjF,4CAA4C,cAAc,EAAE;AAC5D,uCAAuC,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE/F;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,4BAA4B,KAAK,yBAAyB,EAAE,EAAE;;AAE9D,iDAAiD;AACjD;EACE,oFAAoF;EACpF,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,sEAAsE;EACtE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,6BAA6B;EAC7B,uCAAuC;EACvC,+CAA+C;EAC/C,sDAAsD;AACxD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;EAME,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,qBAAqB;EACrB,wCAAwC;EACxC,2CAA2C;EAC3C,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD,oDAAoD;EACpD,8CAA8C;EAC9C,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kDAAkD,WAAW,EAAE,YAAY,EAAE;AAC7E,mDAAmD,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACxK,qDAAqD,cAAc,EAAE,uBAAuB,EAAE;;AAE9F,gFAAgF;AAChF;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;EACR,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;;;;;EAKE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,yEAAyE;EACzE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;AACF;AACA,qFAAqF;AACrF;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sGAAsG;EACtG,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,gEAAgE;AAClE;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,gCAAgC,KAAK,2BAA2B,EAAE,EAAE;;AAEpE;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,gCAAgC,YAAY,EAAE,qBAAqB,EAAE;;AAErE;EACE,wBAAwB;EACxB,gDAAgD;EAChD,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8CAA8C,0BAA0B,EAAE;AAC1E,4CAA4C,yBAAyB,EAAE;;AAEvE;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,sCAAsC,wBAAwB,EAAE;;AAEhE;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,oFAAoF;EACpF,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA,uCAAuC,2DAA2D,EAAE;AACpG,8CAA8C,gBAAgB,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AAChH,4CAA4C,oBAAoB,EAAE,2CAA2C,EAAE,2BAA2B,EAAE,kCAAkC,EAAE,2BAA2B,EAAE;;AAE7M;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,yDAAyD;EACzD,2DAA2D;AAC7D;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,yCAAyC,2BAA2B,EAAE;AACtE,uCAAuC,oBAAoB,EAAE;AAC7D;;sCAEsC,6BAA6B,EAAE,4BAA4B,EAAE;;AAEnG;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gCAAgC;EAChC,+DAA+D;AACjE;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yDAAyD;EACzD,qBAAqB;EACrB,0BAA0B;AAC5B","sourcesContent":["/* CarrerUp Mobile Arena\n   Native-only presentation layer. The responsive website remains untouched. */\n\nhtml.native-app {\n  --cu-mobile-orange: #e95a13;\n  --cu-mobile-navy: #17344f;\n  --cu-mobile-blue: #4e7799;\n  --cu-mobile-surface: #ffffff;\n  --cu-mobile-canvas: #f5f7f9;\n  --cu-mobile-line: rgba(78, 119, 153, .14);\n  --cu-mobile-shadow: 0 10px 30px rgba(23, 52, 79, .08);\n  background: var(--cu-mobile-canvas);\n}\n\nhtml.native-app body,\nhtml.native-app #root {\n  background: var(--cu-mobile-canvas);\n}\n\nhtml.native-app button,\nhtml.native-app a,\nhtml.native-app [role=\"button\"] {\n  -webkit-tap-highlight-color: transparent;\n}\n\n/* Instagram-inspired native top bar. */\nhtml.native-app .admin-dash-navbar {\n  box-sizing: border-box;\n  min-height: calc(58px + env(safe-area-inset-top, 0px));\n  padding: env(safe-area-inset-top, 0px) 14px 0 !important;\n  border-bottom: 0;\n  background: transparent !important;\n  box-shadow: none !important;\n  backdrop-filter: none;\n}\n\nhtml.native-app .admin-dash-navbar.native-subpage-header {\n  display: none !important;\n}\n\nhtml.native-app .dashboard-main:not(.feed-canvas) {\n  padding-top: env(safe-area-inset-top, 0px) !important;\n}\n\nhtml.native-app .admin-dash-navbar > .admin-dash-navbar-left,\nhtml.native-app .admin-dash-navbar > .admin-dash-navbar-center,\nhtml.native-app .admin-dash-navbar > .admin-dash-navbar-right {\n  display: none !important;\n}\n\nhtml.native-app .native-topbar {\n  display: grid;\n  grid-template-columns: 44px 1fr auto;\n  align-items: center;\n  width: 100%;\n  height: 58px;\n}\n\nhtml.native-app .native-topbar button {\n  position: relative;\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  color: #17344f;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  font-size: 21px;\n}\n\nhtml.native-app .native-topbar-create {\n  font-size: 23px !important;\n}\n\nhtml.native-app .native-topbar-brand {\n  justify-self: center;\n  width: 132px;\n  height: 38px;\n  object-fit: contain;\n}\n\nhtml.native-app .native-topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\nhtml.native-app .native-notification-button > span {\n  position: absolute;\n  top: 1px;\n  right: -2px;\n  display: grid;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 3px;\n  place-items: center;\n  color: #fff;\n  border: 2px solid #fff;\n  border-radius: 10px;\n  background: #e95a13;\n  font-size: 8px;\n  font-weight: 800;\n}\n\nhtml.native-app .admin-dash-navbar-left {\n  min-width: 0;\n}\n\nhtml.native-app .admin-dash-logo img {\n  width: 38px !important;\n  height: 38px !important;\n  object-fit: contain;\n}\n\nhtml.native-app .admin-dash-navbar-right {\n  gap: 7px;\n}\n\nhtml.native-app .admin-dash-icon-wrapper,\nhtml.native-app .notif-bell-wrap {\n  width: 38px;\n  height: 38px;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n}\n\n/* Five-destination native navigation. */\nhtml.native-app .mobile-bottom-nav {\n  box-sizing: border-box;\n  right: max(8px, env(safe-area-inset-right, 0px)) !important;\n  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px) !important;\n  left: max(8px, env(safe-area-inset-left, 0px)) !important;\n  z-index: 99990;\n  display: grid !important;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  width: auto !important;\n  min-height: 58px;\n  padding: 3px 5px 2px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: rgba(255, 255, 255, .97) !important;\n  box-shadow: 0 -1px rgba(23, 52, 79, .08) !important;\n  backdrop-filter: blur(20px) !important;\n}\n\nhtml.native-app .mobile-bottom-nav > div {\n  position: relative;\n  display: flex !important;\n  min-width: 0;\n  min-height: 50px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 0 !important;\n  color: #71899b !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .mobile-bottom-nav > .mobile-native-only {\n  display: flex;\n}\n\nhtml.native-app .mobile-bottom-nav > .mobile-web-only {\n  display: none !important;\n}\n\nhtml.native-app .mobile-bottom-nav > div::before,\nhtml.native-app .mobile-bottom-nav > div::after {\n  display: none !important;\n}\n\nhtml.native-app .mobile-bottom-nav > div > svg {\n  width: 19px;\n  height: 19px;\n  color: inherit !important;\n  filter: none !important;\n  transform: none !important;\n  animation: none !important;\n}\n\nhtml.native-app .mobile-bottom-nav > div > span {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  font-size: 8.5px;\n  font-weight: 750;\n  line-height: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nhtml.native-app .mobile-bottom-nav > div.active {\n  color: var(--cu-mobile-orange) !important;\n  background: transparent !important;\n}\n\nhtml.native-app .native-create-overlay {\n  position: fixed;\n  z-index: 100500;\n  inset: 0;\n  display: flex;\n  align-items: flex-end;\n  padding: 18px 12px calc(env(safe-area-inset-bottom, 0px) + 14px);\n  box-sizing: border-box;\n  background: rgba(8, 22, 34, .48);\n  backdrop-filter: blur(7px);\n}\n\nhtml.native-app .native-create-sheet {\n  width: 100%;\n  padding: 18px;\n  box-sizing: border-box;\n  border-radius: 26px;\n  background: #fff;\n  box-shadow: 0 24px 65px rgba(10, 28, 42, .28);\n  animation: nativeSheetIn .28s cubic-bezier(.2, .8, .2, 1);\n}\n\nhtml.native-app .native-create-sheet header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\nhtml.native-app .native-create-sheet header small {\n  color: #e95a13;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: .12em;\n  text-transform: uppercase;\n}\n\nhtml.native-app .native-create-sheet header h2 {\n  margin: 2px 0 0;\n  color: #17344f;\n  font-size: 21px;\n}\n\nhtml.native-app .native-create-sheet header button {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  place-items: center;\n  color: #17344f;\n  border: 0;\n  border-radius: 50%;\n  background: #f1f4f6;\n}\n\nhtml.native-app .native-create-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\nhtml.native-app .native-create-grid button {\n  display: flex;\n  min-height: 76px;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  color: #17344f;\n  border: 0;\n  border-radius: 17px;\n  background: #f3f6f8;\n  font-size: 14px;\n  font-weight: 750;\n  text-align: left;\n}\n\nhtml.native-app .native-create-grid button svg {\n  box-sizing: content-box;\n  width: 18px;\n  height: 18px;\n  padding: 10px;\n  color: #e95a13;\n  border-radius: 12px;\n  background: #fff0e8;\n}\n\n@keyframes nativeSheetIn {\n  from { opacity: 0; transform: translateY(32px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Feed: immersive mobile cards, no desktop side content. */\nhtml.native-app .dashboard-main.feed-canvas {\n  padding: calc(env(safe-area-inset-top, 0px) + 70px) 0 108px !important;\n  background: #fff;\n}\n\nhtml.native-app .feed-canvas .feed,\nhtml.native-app .feed-layout,\nhtml.native-app .feed-stream {\n  width: 100% !important;\n  max-width: none !important;\n}\n\nhtml.native-app .feed-composer {\n  display: none !important;\n}\n\nhtml.native-app .feed-mobile-sections {\n  display: none !important;\n}\n\nhtml.native-app .native-search-page {\n  min-height: calc(100dvh - 150px);\n  padding: 12px 14px 100px;\n  box-sizing: border-box;\n  background: #fff;\n}\n\nhtml.native-app .native-section-back {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  align-items: center;\n  gap: 12px;\n  padding: 0 14px;\n  color: #17344f;\n  border: 0;\n  border-bottom: 1px solid #e9edf0;\n  background: #fff;\n  font-size: 16px;\n  font-weight: 750;\n  text-align: left;\n}\n\nhtml.native-app .native-page-header {\n  display: grid;\n  grid-template-columns: 42px 1fr 42px;\n  align-items: center;\n  min-height: 48px;\n}\n\nhtml.native-app .native-page-header button {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  place-items: center;\n  color: #17344f;\n  border: 0;\n  background: transparent;\n}\n\nhtml.native-app .native-page-header h1 {\n  margin: 0;\n  color: #17344f;\n  font-size: 19px;\n  text-align: center;\n}\n\nhtml.native-app .native-search-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 10px 0 16px;\n  padding: 0 13px;\n  border-radius: 14px;\n  background: #f0f3f5;\n  color: #71899b;\n}\n\nhtml.native-app .native-search-field input {\n  width: 100%;\n  height: 48px;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #17344f;\n  font-size: 15px;\n}\n\nhtml.native-app .native-search-field button {\n  display: grid;\n  padding: 5px;\n  place-items: center;\n  color: #71899b;\n  border: 0;\n  background: transparent;\n}\n\nhtml.native-app .native-search-user {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 2px;\n  color: #17344f;\n  border: 0;\n  border-bottom: 1px solid #edf0f2;\n  background: #fff;\n  text-align: left;\n}\n\nhtml.native-app .native-search-avatar {\n  display: grid;\n  width: 48px;\n  height: 48px;\n  flex: 0 0 48px;\n  overflow: hidden;\n  place-items: center;\n  border-radius: 50%;\n  background: #edf2f5;\n}\n\nhtml.native-app .native-search-avatar img { width: 100%; height: 100%; object-fit: cover; }\nhtml.native-app .native-search-user > span:last-child { display: grid; gap: 3px; }\nhtml.native-app .native-search-user small { color: #7890a2; }\nhtml.native-app .native-search-state { padding: 30px 10px; color: #7890a2; text-align: center; }\n\nhtml.native-app .feed-canvas .post {\n  width: 100%;\n  margin: 0;\n  padding: 0 0 8px;\n  overflow: hidden;\n  border: 0;\n  border-bottom: 8px solid #eef2f4;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\nhtml.native-app .feed-canvas .post-header {\n  padding: 14px 15px 11px;\n}\n\nhtml.native-app .feed-canvas .post-header img,\nhtml.native-app .feed-canvas .post-header .post-user-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\nhtml.native-app .feed-canvas .post-text-wrapper {\n  padding: 0 15px 12px;\n}\n\nhtml.native-app .feed-canvas .post-image,\nhtml.native-app .feed-canvas .post-video-container {\n  width: 100%;\n  max-height: 72dvh;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  background: #102432;\n  cursor: default;\n  object-fit: contain;\n}\n\nhtml.native-app .feed-canvas .post-actions {\n  margin: 0;\n  padding: 10px 13px 8px;\n  border: 0;\n  background: transparent;\n}\n\nhtml.native-app .feed-canvas .post-actions button {\n  min-height: 38px;\n  border-radius: 0;\n  background: transparent !important;\n}\n\nhtml.native-app .native-feed-welcome {\n  display: grid;\n  gap: 3px;\n  padding: 17px 15px 13px;\n  border-bottom: 1px solid #e9edef;\n  background: #fff;\n}\n\nhtml.native-app .native-feed-welcome small {\n  color: #e95a13;\n  font-size: 9px;\n  font-weight: 850;\n  letter-spacing: .14em;\n  text-transform: uppercase;\n}\n\nhtml.native-app .native-feed-welcome strong {\n  color: #17344f;\n  font-size: 18px;\n  font-weight: 780;\n}\n\nhtml.native-app .native-pull-refresh {\n  display: grid;\n  height: var(--pull-distance, 0px);\n  overflow: hidden;\n  place-items: end center;\n  background: #fff;\n  transition: height .18s ease;\n}\n\nhtml.native-app .native-pull-refresh > span {\n  width: 22px;\n  height: 22px;\n  margin-bottom: 9px;\n  border: 2px solid #d7e0e5;\n  border-top-color: #e95a13;\n  border-radius: 50%;\n  transform: rotate(calc(var(--pull-distance, 0px) * 3));\n}\n\nhtml.native-app .native-pull-refresh.refreshing > span {\n  animation: nativePullSpin .75s linear infinite;\n}\n\n@keyframes nativePullSpin { to { transform: rotate(360deg); } }\n\n/* Instagram-like post viewer on native mobile. */\nhtml.native-app .pv-overlay {\n  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;\n  background: #0d1f2c !important;\n  backdrop-filter: none !important;\n}\n\nhtml.native-app .pv-modal {\n  width: 100% !important;\n  height: 100% !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .pv-close {\n  top: 10px;\n  left: 10px;\n  right: auto;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(8, 23, 34, .72);\n}\n\n/* Profile: native hierarchy and Instagram-style back control. */\nhtml.native-app .pro-profile-container {\n  padding: calc(env(safe-area-inset-top, 0px) + 10px) 0 105px !important;\n  background: var(--cu-mobile-canvas);\n}\n\nhtml.native-app .profile-container {\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n}\n\nhtml.native-app .sport-profile-topbar {\n  position: sticky;\n  z-index: 30;\n  top: env(safe-area-inset-top, 0px);\n  padding: 8px 10px;\n  background: rgba(245, 247, 249, .92);\n  backdrop-filter: blur(16px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\nhtml.native-app .native-profile-menu-wrap {\n  position: relative;\n  z-index: 50;\n  display: block;\n}\n\nhtml.native-app .native-profile-menu-trigger {\n  position: relative;\n  z-index: 52;\n  display: grid;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  place-items: center;\n  color: #17344f;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  font-size: 20px;\n}\n\nhtml.native-app .native-profile-menu-backdrop {\n  position: fixed;\n  z-index: 49;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: rgba(10, 25, 38, .22);\n  backdrop-filter: blur(3px);\n}\n\nhtml.native-app .native-profile-menu {\n  position: absolute;\n  z-index: 51;\n  top: 48px;\n  right: 0;\n  display: grid;\n  width: min(270px, calc(100vw - 28px));\n  padding: 8px;\n  border: 1px solid var(--cu-mobile-line);\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 20px 55px rgba(14, 38, 56, .22);\n}\n\nhtml.native-app .native-profile-menu > button {\n  display: flex;\n  min-height: 49px;\n  align-items: center;\n  gap: 13px;\n  padding: 0 12px;\n  color: #17344f;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n}\n\nhtml.native-app .native-profile-menu > button svg {\n  width: 18px;\n  color: #71899b;\n}\n\nhtml.native-app .native-profile-menu > .native-profile-logout,\nhtml.native-app .native-profile-menu > .native-profile-logout svg {\n  color: #d44334;\n}\n\nhtml.native-app .sport-back-btn,\nhtml.native-app .back-btn {\n  width: 40px !important;\n  min-width: 40px;\n  height: 40px;\n  padding: 0 !important;\n  display: grid !important;\n  place-items: center;\n  overflow: hidden;\n  border: 1px solid var(--cu-mobile-line) !important;\n  border-radius: 50% !important;\n  color: var(--cu-mobile-navy) !important;\n  background: rgba(255, 255, 255, .96) !important;\n  box-shadow: 0 5px 14px rgba(23, 52, 79, .1) !important;\n}\n\nhtml.native-app .sport-back-btn .back-arrow {\n  font-size: 0;\n}\n\nhtml.native-app .sport-back-btn .back-arrow::before {\n  content: \"‹\";\n  font-size: 31px;\n  font-weight: 400;\n  line-height: 1;\n}\n\nhtml.native-app .sport-back-btn .back-content {\n  display: none !important;\n}\n\nhtml.native-app .main-profile-header,\nhtml.native-app .profile-summary,\nhtml.native-app .profile-links-section,\nhtml.native-app .highlights-section,\nhtml.native-app .tabs,\nhtml.native-app .posts-grid {\n  margin-right: 10px !important;\n  margin-left: 10px !important;\n}\n\nhtml.native-app .main-profile-header {\n  padding: 18px 14px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .cta-buttons .btn {\n  min-height: 44px;\n  border-radius: 13px;\n}\n\nhtml.native-app .cta-buttons .profile-edit-btn {\n  display: none !important;\n}\n\nhtml.native-app .profile-summary,\nhtml.native-app .profile-links-section,\nhtml.native-app .highlights-section {\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .profile-container > .tabs {\n  display: grid !important;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  padding: 0 !important;\n  border-top: 1px solid #e8edf0 !important;\n  border-bottom: 1px solid #e8edf0 !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .profile-container > .tabs button {\n  position: relative;\n  display: grid;\n  height: 52px;\n  padding: 0;\n  place-items: center;\n  color: #8aa0b0;\n  border: 0;\n  background: transparent !important;\n}\n\nhtml.native-app .profile-container > .tabs button.active {\n  color: #17344f !important;\n}\n\nhtml.native-app .profile-container > .tabs button.active::after {\n  content: \"\";\n  position: absolute;\n  right: 18%;\n  bottom: -1px;\n  left: 18%;\n  height: 2px;\n  border-radius: 2px;\n  background: #17344f;\n}\n\nhtml.native-app .profile-container > .tabs .profile-tab-label {\n  display: none;\n}\n\nhtml.native-app .profile-container > .tabs .native-profile-tab-icon {\n  display: grid;\n  place-items: center;\n  font-size: 19px;\n}\n\nhtml.native-app .native-profile-dock {\n  box-sizing: border-box;\n  position: fixed;\n  z-index: 99990;\n  right: max(8px, env(safe-area-inset-right, 0px));\n  bottom: calc(env(safe-area-inset-bottom, 0px) + 8px);\n  left: max(8px, env(safe-area-inset-left, 0px));\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  width: auto;\n  min-height: 58px;\n  padding: 3px 5px 2px;\n  border: 0;\n  border-radius: 0;\n  background: rgba(255, 255, 255, .97);\n  box-shadow: 0 -1px rgba(23, 52, 79, .08);\n  backdrop-filter: blur(20px);\n}\n\nhtml.native-app .native-profile-dock button {\n  display: flex;\n  min-width: 0;\n  min-height: 51px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 0;\n  color: #71899b;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\nhtml.native-app .native-profile-dock button svg { width: 19px; height: 19px; }\nhtml.native-app .native-profile-dock button span { max-width: 100%; overflow: hidden; font-size: 8.5px; font-weight: 750; text-overflow: ellipsis; white-space: nowrap; }\nhtml.native-app .native-profile-dock button.active { color: #e95a13; background: transparent; }\n\n/* Matching becomes a native discovery deck while preserving its data/actions. */\nhtml.native-app .matching-page {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 100dvh;\n  padding: 14px 10px 108px;\n  background: var(--cu-mobile-canvas);\n}\n\nhtml.native-app .matching-hero {\n  margin-bottom: 14px;\n  padding: 19px 17px;\n  border-radius: 20px;\n  box-shadow: var(--cu-mobile-shadow);\n}\n\nhtml.native-app .matching-page .suggestion-row {\n  gap: 10px;\n  margin-inline: -10px;\n  padding: 2px 10px 18px;\n  scroll-padding-inline: 10px;\n  scrollbar-width: none;\n}\n\nhtml.native-app .matching-page .suggestion-row::-webkit-scrollbar {\n  display: none;\n}\n\nhtml.native-app .matching-page .match-card,\nhtml.native-app .matching-page .match-card-mine {\n  border-radius: 20px;\n  box-shadow: var(--cu-mobile-shadow);\n}\n\nhtml.native-app .matching-list-scroll {\n  max-height: none;\n  overflow: visible;\n  padding: 0;\n}\n\nhtml.native-app .matching-list .match-card-mine {\n  grid-template-columns: 1fr;\n  gap: 9px;\n  padding: 15px;\n}\n\n/* Network and chat retain every action with a lighter native canvas. */\nhtml.native-app .network-page {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 14px 10px 108px !important;\n  background: var(--cu-mobile-canvas);\n}\n\nhtml.native-app .network-page .network-card {\n  border-radius: 19px;\n  box-shadow: var(--cu-mobile-shadow);\n}\n\nhtml.native-app .ig-chat-layout {\n  height: calc(100dvh - env(safe-area-inset-top, 0px) - 74px);\n  margin: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: var(--cu-mobile-surface);\n}\n\nhtml.native-app .ig-conversation-item,\nhtml.native-app .ig-message-bubble {\n  border-radius: 16px;\n}\n\n/* Settings and role pages share mobile-safe spacing without changing content. */\nhtml.native-app .settings-container,\nhtml.native-app .profile-settings-container,\nhtml.native-app .club-offers-page,\nhtml.native-app .offer-details-page,\nhtml.native-app .offer-applications-page {\n  box-sizing: border-box;\n  width: 100% !important;\n  max-width: none !important;\n  padding-right: 10px !important;\n  padding-bottom: calc(104px + env(safe-area-inset-bottom, 0px)) !important;\n  padding-left: 10px !important;\n}\n\n@media (max-width: 370px) {\n  html.native-app .mobile-bottom-nav > div > span {\n    font-size: 7.5px;\n  }\n\n  html.native-app .mobile-bottom-nav > div > svg {\n    width: 17px;\n    height: 17px;\n  }\n}\n\n@media (orientation: landscape) and (max-height: 520px) {\n  html.native-app .mobile-bottom-nav {\n    min-height: 56px;\n    padding-block: 4px !important;\n  }\n\n  html.native-app .mobile-bottom-nav > div {\n    min-height: 46px;\n  }\n\n  html.native-app .mobile-bottom-nav > .mobile-create-action {\n    transform: translateY(-10px);\n  }\n}\n/* Native profile correction pass: full-screen panels and compact Instagram layout. */\nhtml.native-app .pro-profile-container,\nhtml.native-app .profile-container {\n  min-height: 100dvh;\n  overflow: visible !important;\n}\n\nhtml.native-app .native-profile-menu {\n  position: fixed;\n  z-index: 51;\n  inset: 0 0 0 auto;\n  display: flex;\n  width: min(88vw, 360px);\n  padding: calc(env(safe-area-inset-top, 0px) + 72px) 14px calc(env(safe-area-inset-bottom, 0px) + 20px);\n  box-sizing: border-box;\n  flex-direction: column;\n  border: 0;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -18px 0 48px rgba(14, 38, 56, .2);\n  animation: nativePanelFromRight .28s cubic-bezier(.2, .8, .2, 1);\n}\n\n@keyframes nativePanelFromRight {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes nativePanelToRight { to { transform: translateX(100%); } }\n\nhtml.native-app .profile-header {\n  display: grid !important;\n  grid-template-columns: 88px minmax(0, 1fr);\n  align-items: center;\n  gap: 14px;\n}\n\nhtml.native-app .photo-wow {\n  width: 82px !important;\n  height: 82px !important;\n  min-width: 82px !important;\n}\n\nhtml.native-app .profile-info { min-width: 0; padding: 0 !important; }\n\nhtml.native-app .profile-info .stats {\n  display: grid !important;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 4px !important;\n  margin-top: 12px !important;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .profile-info .stats > div {\n  min-width: 0;\n  padding: 0 2px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  text-align: center;\n}\n\nhtml.native-app .profile-info .stats strong { font-size: 15px !important; }\nhtml.native-app .profile-info .stats span { font-size: 9px !important; }\n\nhtml.native-app .cta-buttons {\n  display: flex !important;\n  width: auto !important;\n  margin: 10px 14px !important;\n  flex-wrap: wrap;\n  gap: 7px !important;\n}\n\nhtml.native-app .cta-buttons .btn {\n  width: auto !important;\n  min-width: 0 !important;\n  min-height: 36px !important;\n  flex: 0 1 auto !important;\n  padding: 7px 12px !important;\n  border-radius: 9px !important;\n  font-size: 12px !important;\n}\n\nhtml.native-app .skeleton-highlight { display: none !important; }\n\nhtml.native-app .follow-page-overlay {\n  z-index: 100200;\n  display: block !important;\n  padding: 0 !important;\n  background: #fff !important;\n  backdrop-filter: none !important;\n}\n\nhtml.native-app .follow-page,\nhtml.native-app .follow-page.closing {\n  position: fixed !important;\n  inset: 0 !important;\n  width: 100vw !important;\n  height: 100dvh !important;\n  max-width: none !important;\n  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;\n  box-sizing: border-box;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  animation: nativePanelFromRight .3s cubic-bezier(.2, .8, .2, 1) !important;\n}\n\nhtml.native-app .follow-page.closing { animation: nativePanelToRight .25s ease forwards !important; }\nhtml.native-app .follow-page .follow-header { min-height: 56px; padding: 8px 12px !important; background: #fff; }\nhtml.native-app .follow-page .follow-item { border: 0 !important; border-bottom: 1px solid #edf0f2 !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; }\n\nhtml.native-app .mobile-bottom-nav,\nhtml.native-app .native-profile-dock {\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  min-height: calc(58px + env(safe-area-inset-bottom, 0px));\n  padding-bottom: env(safe-area-inset-bottom, 0px) !important;\n}\n\nhtml.native-app .mobile-bottom-nav > div > svg,\nhtml.native-app .native-profile-dock button svg {\n  width: 22px !important;\n  height: 22px !important;\n  stroke-width: 1.4;\n}\n\nhtml.native-app .pro-profile-container { background: #fff !important; }\nhtml.native-app .main-profile-header { margin: 0 !important; }\nhtml.native-app .profile-summary,\nhtml.native-app .profile-links-section,\nhtml.native-app .highlights-section { margin-right: 14px !important; margin-left: 14px !important; }\n\nhtml.native-app .post-page-overlay {\n  z-index: 100250 !important;\n  display: block !important;\n  padding: 0 !important;\n  background: #fff !important;\n  backdrop-filter: none !important;\n  animation: nativePanelFromRight .3s cubic-bezier(.2, .8, .2, 1);\n}\n\nhtml.native-app .post-page-overlay > .post-modal {\n  position: fixed !important;\n  inset: 0 !important;\n  width: 100vw !important;\n  height: 100dvh !important;\n  max-height: none !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\nhtml.native-app .post-page-overlay .pv-overlay {\n  padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) !important;\n  background: #fff !important;\n}\n\nhtml.native-app .post-page-overlay .pv-modal {\n  width: 100vw !important;\n  height: 100dvh !important;\n  max-height: none !important;\n  border-radius: 0 !important;\n  background: #fff !important;\n}\n\nhtml.native-app .post-page-overlay .pv-close {\n  position: fixed !important;\n  top: calc(env(safe-area-inset-top, 0px) + 8px) !important;\n  left: 10px !important;\n  z-index: 100300 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
